export default {
  namespaced: true,
  state: {
    all: [],
    loading: false
  },
  getters: {
    all: (state) => state.all,
    find: (state) => (id) => state.all.find(competency => competency.id == id),
    loading: (state) => state.loading
  },
  mutations: {
    startLoading(state) {
      state.loading = true
    },
    stopLoading(state) {
      state.loading = false
    },
    setAll(state, competencies) {
      state.all = competencies
      state.loading = false
    }
  },
  actions: {
    fetchAll({ commit }) {
      commit('startLoading')
      return Vue.$http.get('behavioral_competencies').then(
        (response) => commit('setAll', response.data),
        (response) => commit('stopLoading')
      )
    }
  }
}
